import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

export default function BlockingDialog({
  open,
  onOpenChange,
  blockingData,
  setBlockingData,
  onSubmit
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Bloquer des dates</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">
          Les dates bloquées apparaîtront sur le calendrier mais ne seront pas comptabilisées dans les statistiques.
        </p>
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label>Date de début</Label>
              <Input
                type="date"
                value={blockingData.check_in}
                onChange={(e) => setBlockingData({ ...blockingData, check_in: e.target.value })}
              />
            </div>
            <div>
              <Label>Date de fin</Label>
              <Input
                type="date"
                value={blockingData.check_out}
                onChange={(e) => setBlockingData({ ...blockingData, check_out: e.target.value })}
              />
            </div>
          </div>
          <div>
            <Label>Raison (optionnel)</Label>
            <Input
              placeholder="Ex: Vacances, travaux, usage personnel..."
              value={blockingData.blocked_reason}
              onChange={(e) => setBlockingData({ ...blockingData, blocked_reason: e.target.value })}
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Annuler</Button>
          <Button onClick={onSubmit}>Bloquer ces dates</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
